import React, { useState } from "react";
import { TextField, Button, Typography, Box, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/logo.webp"; 
import backgroundImage from "../assets/logobg.avif"; 

// Styled component for the background
const BackgroundContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

// Styled component for the form container
const FormContainer = styled(Box)`
  width: 100%;
  max-width: 400px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
`;

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (username.trim() && password.trim()) {
      localStorage.setItem("isLoggedIn", "true");
      navigate("/home");
    } else {
      alert("Please enter both username and password");
    }
  };

  const handleGuestEntry = () => {
    navigate("/home");
  };

  return (
    <BackgroundContainer>
      <FormContainer>
        <img src={logo} alt="Growsphere Logo" style={{ width: "80px", marginBottom: "10px" }} />
        <Typography variant="h5" gutterBottom sx={{ color: "#2e7d32", fontWeight: "bold" }}>
          Login
        </Typography>
        <form onSubmit={handleLogin}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2, bgcolor: "#4caf50", "&:hover": { bgcolor: "#388e3c" } }}
          >
            Login
          </Button>
        </form>
        <Divider sx={{ my: 2 }}>OR</Divider>
        <Button
          variant="outlined"
          fullWidth
          sx={{ borderColor: "#4caf50", color: "#4caf50", "&:hover": { bgcolor: "#c8e6c9" } }}
          onClick={handleGuestEntry}
        >
          Enter as Guest
        </Button>
      </FormContainer>
    </BackgroundContainer>
  );
};

export default Login;
